import { Component, Input } from '@angular/core';
import { MaterialModule } from 'jk-service';
import { JkgridwinComponent } from 'jk-advcom';
import { jkLib } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';

@Component({
  selector: 'app-view-market',
  standalone: true,
  imports: [MaterialModule,
    JkgridwinComponent,
    JackBaseComponentModule,
  ],
  templateUrl: './view-market.component.html',
  styleUrl: './view-market.component.css'
})
export class ViewMarketComponent {
  onValueChange($event: string) {
    throw new Error('Method not implemented.');
  }
  stkmpGrid!: JkgridwinComponent;
  _date: string = jkLib.nowDate();
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() get date(): string {
    return this._date;
  }
  set date(value: string) {
    this._date = value;
    this.doQuery();
  }
  constructor() { }
  afterGridReady($event: JkgridwinComponent) {
    this.stkmpGrid = $event;
    this.doQuery();
  }
  doQuery() {
    if (!this.date) return;
    let where = ''; // ` AND MP001='${this.date}'`; 取最後24筆
    this.stkmpGrid.doQuery2('STKMP', '001', 'S', where);
  }

}
